import DateFnsUtils from '@date-io/date-fns';
import { Button, Grid, IconButton, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { KeyboardBackspaceOutlined } from '@material-ui/icons';
import { Alert, AlertTitle } from '@material-ui/lab';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import axios from 'axios';
import { Form, Formik, FormikProps } from 'formik';
import { useSnackbar } from 'notistack';
import { FunctionComponent } from 'react';
import { useHistory } from "react-router-dom";
import { Help } from '../components/atoms/Help';
import { AppInput } from '../components/atoms/inputs/AppInput';
import { LoadingButton } from '../components/atoms/inputs/LodingButton';
import { AuthShell } from '../components/molecules/auth-shell/AuthShell';
import { ApiResponse } from '../types';

const useStyles = makeStyles((theme) => ({
    ppoInput: {
        "& label": {
            color: theme.palette.primary.main,
        },
        "& value": {
            color: theme.palette.primary.main,
        }

    }

}));

type ChangeMobileNumberState = {
    state: number,
    erpId: string,
    dob: Date,
    message: { type: "error" | "success", message: string } | null,
    contactNo: string,
    otpReference: string,
    otp: string
}


interface UpdateMobileNumberPageProps {
}

export const UpdateMobileNumberPage: FunctionComponent<UpdateMobileNumberPageProps> = () => {
    const classes = useStyles();
    const history = useHistory();
    const { enqueueSnackbar } = useSnackbar();

    return (
        <AuthShell>
            <Formik
                initialValues={{
                    state: 0, // 0 -> OTP Not Yet Send, 1 -> OTP Send but not yet provided by user
                    message: null,
                    dob: new Date(),
                    erpId: "",
                    contactNo: "",
                    otpReference: "",
                    otp: "",
                }}

                validate={(values) => {
                    const errors: Partial<ChangeMobileNumberState> & { general?: string } = {}
                    if (!values.erpId || !values.erpId.match(/^\d{8}$|^[\d\/]{11}$/)) { //TODO Rectify Regex for legecy PPO
                        errors.erpId = ('Valid PPO Number Required (বৈধ পিপিও নম্বর প্রয়োজনীয়)');
                    }
                    if (!values.contactNo || !values.contactNo.match(/^[6-9]{1}[0-9]{9}$/)) {
                        errors.contactNo = 'Valid Mobile Number Required (বৈধ মোবাইল নম্বর আবশ্যক)'
                    }
                    if (values.state > 0 && !values.otp && !values.otp.match(/^\d{6}$/)) {
                        errors.otp = 'OTP Required (ওটিপি প্রয়োজনীয়)'
                    }
                    return errors
                }}
                onSubmit={async (values, { setSubmitting, setFieldValue, setFieldTouched, resetForm, setFieldError }) => {
                    setSubmitting(true);
                    setFieldValue('message', null)
                    try {
                        if (values.state === 0) {
                            // Send OTP
                            await axios.get<ApiResponse<{ otpReference: string, mobileNumber: string }>>(`/api/auth/request-mobile-change/${values.dob.toISOString().split('T')[0]}/${values.contactNo}/${values.erpId}`)
                                .then(
                                    ({ data: resp }) => {
                                        if (resp.status === "success") {
                                            setFieldValue('otpReference', resp.data.otpReference)
                                            setFieldValue('state', 1)
                                        } else {
                                            setFieldValue('message', { type: "error", message: resp.message || 'Error Occured' })
                                            enqueueSnackbar(resp.message || 'Error Occured', { variant: 'error' })
                                        }
                                    },
                                    () => {
                                        setFieldValue('message', { type: "error", message: "Network Error" })
                                        enqueueSnackbar('Network Error', { variant: 'error' })
                                    }
                                )
                        } else {
                            // Verify OTP
                            await axios.post<ApiResponse<{ username: string, name: string, jwt: string, refreshToken: string }>>
                                ('/api/auth/change-mobile-no', { otp_reference: values.otpReference, otp: values.otp })
                                .then(
                                    ({ data: resp }) => {
                                        if (resp.status === "success") {
                                            resetForm()
                                            setFieldValue('message', { type: "success", message: resp.message || 'Successfully' })
                                            enqueueSnackbar(resp.message, { variant: 'success' })
                                        }
                                        else {
                                            setFieldValue('message', { type: "error", message: resp.message || 'Error Occured' })
                                            enqueueSnackbar(resp.message || 'Error Occured', { variant: 'error' })
                                        }
                                    },
                                    () => {
                                        setFieldValue('message', { type: "error", message: "Network Error" })
                                        enqueueSnackbar('Network Error', { variant: 'error' })
                                    }
                                )
                        }
                    } catch (err) {
                        setFieldError('general', err.message)
                    }
                    finally {
                        setSubmitting(false);
                    }
                }}
            >{({ values, isSubmitting, isValid, setFieldValue, setValues, handleChange }: FormikProps<ChangeMobileNumberState>) => {
                return (
                    <Form>
                        <Grid
                            container
                            direction="column"
                            justify="space-around"
                            alignItems="stretch"
                            spacing={2}
                        >
                            <Grid item container justify="flex-start" alignItems="center">
                                <Grid item xs={2}><IconButton onClick={() => history.push('/login')}> <KeyboardBackspaceOutlined fontSize="large" /></IconButton></Grid>
                                <Grid item xs={10}><Typography variant="h6" color="primary">Update Mobile No (মোবাইল নম্বর আপডেট করুন)</Typography></Grid>
                            </Grid>
                            {
                                values.message &&
                                <Grid item>
                                    <Alert severity={values.message.type}>
                                        <AlertTitle>
                                            {values.message.type === "success" ? "Success" : "Error(ত্রুটি)"}
                                        </AlertTitle>
                                        {values.message.message}
                                    </Alert>
                                </Grid>
                            }
                            <Grid item>
                                <Help heading="PPO Number (পিপিও নম্বর)" body={<div style={{ textAlign: "justify" }}>Enter PPO number starting with 8. (8 দিয়ে শুরু হওয়া PPO নম্বর লিখুন।)</div>}>
                                    <AppInput
                                        inputProps={{ maxLength: 17 }}
                                        fullWidth={true}
                                        label="PPO Number (পিপিও নম্বর)"
                                        name="erpId"
                                        type="text"
                                        className={classes.ppoInput}
                                        disabled={values.state > 0 || isSubmitting}
                                    />
                                </Help>
                            </Grid>
                            <Grid item>
                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <KeyboardDatePicker
                                        fullWidth={true}
                                        required={true}
                                        inputVariant="filled"
                                        className={classes.ppoInput}
                                        label="Date of Birth (জন্ম তারিখ)"
                                        format="dd/MM/yyyy"
                                        value={values.dob}
                                        onChange={value => setFieldValue("dob", value)}
                                        disabled={values.state > 0 || isSubmitting}
                                    />
                                </MuiPickersUtilsProvider>
                            </Grid>
                            <Grid item>
                                <AppInput
                                    inputProps={{ maxLength: 10 }}
                                    fullWidth={true}
                                    className={classes.ppoInput}
                                    label="New Mobile Number (নতুন মোবাইল নম্বর)"
                                    name="contactNo"
                                    type="text"
                                    disabled={values.state > 0 || isSubmitting}
                                />
                            </Grid>
                            {
                                values.state === 0 &&
                                <Grid item container justify="space-between">
                                    <Grid item>
                                        <LoadingButton
                                            type="submit"
                                            color="primary"
                                            variant="contained"
                                            size="large"
                                            loading={isSubmitting}
                                        >Request OTP (ওটিপি প্রেরণ করুন)</LoadingButton>
                                    </Grid>
                                </Grid>
                            }
                            {
                                values.state === 1 &&
                                <>
                                    <Grid item>
                                        <Typography variant="body2" color="primary">OTP has been sent to your mobile (আপনার মোবাইলে ওটিপি পাঠানো হয়েছে)</Typography>
                                        {/* <Typography variant="h6" color="initial">আপনার মোবাইলে ওটিপি পাঠানো হয়েছে</Typography> */}
                                    </Grid>
                                    <Grid item>
                                        <AppInput
                                            inputProps={{ maxLength: 6 }}
                                            fullWidth={true}
                                            label="OTP (ওটিপি)"
                                            name="otp"
                                            type="text"
                                            disabled={isSubmitting}
                                        />
                                    </Grid>
                                    <Grid item container justify="space-between">
                                        <Grid item>
                                            <Button type="reset" disabled={isSubmitting}>Reset (রিসেট)</Button>
                                        </Grid>
                                        <Grid item>
                                            <LoadingButton
                                                type="submit"
                                                color="primary"
                                                variant="contained"
                                                size="large"
                                                loading={isSubmitting}
                                            >Update Mobile No (মোবাইল নম্বর আপডেট করুন)</LoadingButton>
                                        </Grid>
                                    </Grid>
                                </>
                            }
                        </Grid>
                        {/* <pre>{JSON.stringify(values, null, 2)}</pre> */}
                    </Form>
                )
            }}
            </Formik>
        </AuthShell >
    )
}